var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Replace component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconReplace extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.8374 9.94576C22.7213 10.226 22.4479 10.4087 22.1445 10.4087L1.85451 10.4087C1.44029 10.4087 1.10451 10.073 1.10451 9.65875C1.10451 9.24453 1.44029 8.90875 1.85451 8.90875L20.3338 8.90875L16.9319 5.50677C16.639 5.21388 16.639 4.739 16.9319 4.44611C17.2248 4.15322 17.6996 4.15322 17.9925 4.44611L22.6748 9.12842C22.8893 9.34292 22.9535 9.6655 22.8374 9.94576Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.8945 14.3411C22.8945 14.7553 22.5587 15.0911 22.1445 15.0911L3.66519 15.0911L7.06717 18.493C7.36006 18.7859 7.36006 19.2608 7.06717 19.5537C6.77427 19.8466 6.2994 19.8466 6.00651 19.5537L1.3242 14.8714C1.1097 14.6569 1.04553 14.3343 1.16162 14.0541C1.27771 13.7738 1.55118 13.5911 1.85453 13.5911L22.1445 13.5911C22.5587 13.5911 22.8945 13.9269 22.8945 14.3411Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconReplace.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconReplace.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconReplace.prototype, "size", void 0);
if (customElements.get('cat-icon-replace') === undefined) {
    customElements.define('cat-icon-replace', BlocksIconReplace);
}
